/*eslint-disable*/
import api from './'

class RatingApi {

    static list(params, cancelToken = null) {
        return api.axios.get('/rating', {params, cancelToken})
            .then(response => response.data);
    }

    static show(date, params = {}) {
        return api.axios.get(`/rating/${date}`, {params})
            .then(response => response.data.ratings);
    }

}

export default RatingApi;
